<!-- Dialog title based on the presence of table data -->
<div>
  <div class="d-flex justify-content-between">
    <h3 mat-dialog-title class="bg-white customization-head ml-n2">Uber Eats Setup</h3>
    <div class="icon mr-4 mt-3">
      <div class="close-icon" (click)="onCloseModal()">
        <i class="bx bx-x bx-sm"></i>
      </div>
    </div>
  </div>
  <div class="sub-head pl-4">Setup your Uber Eats basic details.</div>

  <mat-dialog-content class="pt-2 pb-1">
    <div class="d-flex flex-column mb-3 pt-2">
      <div class="row">
        <div>
          <label class="form-label pl-0"> Auto Approve Orders: </label>
        </div>
        <div class="checkbox-with-label pb-3 d-flex ml-2">
          <div class="switch ml-3">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                [checked]="orderAutoApprove"
                (change)="toggleOrderAutoApprove($event)"
              />
            </div>
          </div>
          <div class="setting-header ml-3 mt-2 opacity-50">
            <div class="sub-head">Automatically approve orders from Uber Eats</div>
          </div>
        </div>
      </div>
      <div class="row mb-2 pb-3 custom-line-bottom">
        <div>
          <label class="form-label pl-0"> Preparation Time: </label>
        </div>
        <div class="mt-1 d-flex gap-3">
          <div class="input-group">
            <input
              type="number"
              class="form-control border-right-0"
              placeholder="Preparation Time"
              min="5"
              max="180"
              [value]="preparationTime"
              (keydown)="preventNegativeInput($event)"
              (input)="changePreparationTime($event)"
            />
            <span class="preparation-group-text bg-white border-top border-bottom border-left">
              Minutes
            </span>
          </div>
          <!-- <button type="button" class="btn btn-dark rounded-3 common-add-btn w-50" (click)="savePreparationTime()" [disabled]="preparationTimeErrorMessage || preparationTime === 0" >
                        Save
                    </button> -->
        </div>
        @if (preparationTimeErrorMessage) {
          <div class="row">
            <div class="d-flex mt-2 ml-1 errorText gap-1">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>{{ preparationTimeErrorMessage }}</p>
            </div>
          </div>
        }
        <div class="sub-head mt-2">
          Preparation time is the time it takes for the restaurant to prepare the order. Minimum
          time is 5 minutes and maximum time is 180 minutes.
        </div>
        <div class="col-12">
          <button
            type="button"
            class="btn btn-dark rounded-3 common-add-btn w-auto float-end mt-3"
            (click)="savePreparationTime()"
            [disabled]="preparationTimeErrorMessage || preparationTime === 0"
          >
            Save Auto-Approval Settings
          </button>
        </div>
      </div>
      <div class="row">
        <div>
          <label class="form-label pl-0"> Order Availability: </label>
        </div>
        <div class="checkbox-with-label pb-3 d-flex ml-2">
          <div class="switch ml-3">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                [checked]="availability"
                (change)="toggleAvailability($event)"
              />
            </div>
          </div>
          <div class="setting-header ml-3 mt-2 opacity-50">
            <div class="sub-head">Control whether your store can receive new Uber Eats orders.</div>
          </div>
        </div>
      </div>
      @if (disableAvailabilityContent) {
        <form
          class="bg-light-subtle p-3 rounded-3"
          [formGroup]="availabilityForm"
          (ngSubmit)="saveAvailability()"
        >
          <div class="row">
            <div class="col-6">
              <label class="form-label pl-0" for="resume-date"
                >Resume Orders At: <span class="text-danger">*</span></label
              >
              <input
                id="resume-date"
                type="date"
                class="form-control"
                formControlName="resumeDate"
                [min]="minResumeDate"
                [class.is-invalid]="
                  availabilityForm.get('resumeDate')?.invalid &&
                  availabilityForm.get('resumeDate')?.touched
                "
              />
              @if (
                availabilityForm.get('resumeDate')?.invalid &&
                availabilityForm.get('resumeDate')?.touched
              ) {
                <div class="text-danger small mt-1">Resume date is required.</div>
              }
            </div>
            <div class="col-6">
              <label class="form-label pl-0" for="resume-time"
                >Time: <span class="text-danger">*</span></label
              >
              <input
                id="resume-time"
                type="time"
                class="form-control"
                formControlName="resumeTime"
                [min]="minResumeTime"
                [class.is-invalid]="
                  availabilityForm.get('resumeTime')?.invalid &&
                  availabilityForm.get('resumeTime')?.touched
                "
              />
              @if (
                availabilityForm.get('resumeTime')?.invalid &&
                availabilityForm.get('resumeTime')?.touched
              ) {
                <div class="text-danger small mt-1">Time is required.</div>
              }
              @if (
                availabilityForm.errors?.['pastDateTime'] &&
                availabilityForm.get('resumeTime')?.touched
              ) {
                <div class="text-danger small mt-1">Time cannot be in the past.</div>
              }
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12">
              <label class="form-label pl-0" for="resume-reason">Reason:</label>
              <div class="mt-1 d-flex gap-3">
                <input
                  id="resume-reason"
                  type="text"
                  class="form-control"
                  [value]="offlineReasonLabel"
                  readonly
                />
              </div>
            </div>
          </div>
          <div class="row m-0 mt-3 rounded-3 pt-2 pb-1">
            <div
              class="d-flex flex-row justify-content-start align-items-center gap-3 offline-alert-info p-2"
            >
              <span class="bx bx-info-circle bx-sm offline-alert-info-icon"></span>
              <p class="offline-alert-info-text mb-1">
                When turned off, Uber Eats orders will not be received or processed by your system.
              </p>
            </div>
          </div>
          <div class="row justify-content-end mt-4">
            <div class="col-12">
              <button
                type="submit"
                class="btn btn-dark rounded-3 common-add-btn w-auto float-end"
                [disabled]="availabilityForm.invalid"
              >
                Save Changes
              </button>
            </div>
          </div>
        </form>
      }
    </div>
    <div class="custom-line-top mt-4 d-none"></div>
  </mat-dialog-content>

  <!-- Actions -->
  <mat-dialog-actions class="justify-content-end gap-3 pt-3 pb-2 pr-4 d-none">
    <button
      class="btn btn-white border rounded-3 text-black-50 w-25 common-add-btn bg-white"
      mat-dialog-close
    >
      Cancel
    </button>
  </mat-dialog-actions>
</div>
